export const AccordionItem = ({ itemId, itemBodyId, heading, body, selected, setSelected }) => {
  return (
    <div
      className='border transition-all border-[#162735] bg-[#132635]'
      onClick={() => setSelected(selected !== itemId ? itemId : null)}
    >
      <h2>
        <button
          className={`w-full flex items-center justify-between px-5 py-4 text-left text-md md:text-lg  font-medium ${
            selected === itemId ? 'bg-[#061017]' : 'bg-[#061017]'
          } border border-[#162735] rounded-none transition-all duration-150 ease-in-out`}
          type='button'
          aria-expanded={selected === itemId}
          aria-controls={itemBodyId}
        >
          <span className='max-w-[210px] xms:max-w-[250px] sm:max-w-full'>{heading}</span>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth={1.5}
            stroke='currentColor'
            width={30}
            height={30}
            className={`ml-auto w-5 h-5  ${selected === itemId ? '' : 'rotate-180'} transform transition-transform duration-200`}
          >
            <path strokeLinecap='round' strokeLinejoin='round' d='m4.5 15.75 7.5-7.5 7.5 7.5' />
          </svg>
        </button>
      </h2>
      <div
        id={itemBodyId}
        className={`border-x border-[#162735] ${
          selected === itemId ? 'border-b border-b-[#162735]' : 'hidden'
        }`}
        aria-labelledby={itemId}
      >
        <div className='px-5 py-4'>{body}</div>
      </div>
    </div>
  );
};
